import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Guid } from 'guid-typescript';

@Injectable()
export class GuidInterceptor implements HttpInterceptor {
    guid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone();
        this.convertGuidToString(request.body);
        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const body = event.body;
                    this.convertStringToGuid(body);
                }
            }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                    }
                }
            }),
        );
    }

    convertGuidToString(body): any {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            const type = typeof value;
            if (value instanceof (Guid)) {
                body[key] = value.toString();
            } else if (typeof value === 'object') {
                this.convertGuidToString(value);
            }
        }
    }

    convertStringToGuid(body): any {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (this.isGuid(value)) {
                body[key] = Guid.parse(value);
            } else if (typeof value === 'object') {
                this.convertStringToGuid(value);
            }
        }
    }

    isGuid(value): boolean {
        if (value === null || value === undefined) {
            return false;
        }

        return this.guid.test(value);
    }
}
